export default "__VITE_ASSET__D_pTlfW5__"